const css = (strings: TemplateStringsArray, ...values: unknown[]): string =>
  strings.reduce(
    (out, chunk, i) =>
      out + chunk + (i < values.length ? String(values[i]) : ''),
    ''
  );

export default css;
